import { render, staticRenderFns } from "./SaltoIqsTable.vue?vue&type=template&id=0bf78cbc&"
import script from "./SaltoIqsTable.vue?vue&type=script&lang=ts&"
export * from "./SaltoIqsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports